import {
  SET_LIST_PASIEN_ACTIVE_PAGINATION,
  SET_LIST_PASIEN_KEYWORD,
  SET_LIST_PASIEN_DATA,
  SET_LIST_PASIEN_PAGINATION,
  SET_PASIEN_SELECTED,
  SET_PASIEN_SELECTED_FILE,
  SET_PASIEN_DEFAULT_STATE,
  SET_PASIEN_STARTDATE,
  SET_PASIEN_ENDDATE,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  PASIENData: [],
  selectedData: null,
  selectedFile: [],
  activePaginate: 1,
  activeLimit: 10,
  pagination: {
    current_page: 0,
    per_page: 0,
    total: 0,
    last_page: 0,
    from: 0,
  },
  keyword: '',
  startDate: '',
  endDate: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_LIST_PASIEN_DATA: {
      return {
        ...state,
        // InformasiData: [...state.InformasiData, ...action.payload],
        PASIENData: action.payload,
      };
    }
    case SET_LIST_PASIEN_PAGINATION: {
      return {
        ...state,
        pagination: action.payload,
      };
    }
    case SET_LIST_PASIEN_ACTIVE_PAGINATION: {
      return {
        ...state,
        activePaginate: action.payload,
      };
    }
    case SET_LIST_PASIEN_KEYWORD: {
      return {
        ...state,
        keyword: action.payload,
      };
    }
    case SET_PASIEN_SELECTED: {
      return {
        ...state,
        selectedData: action.payload,
      };
    }
    case SET_PASIEN_SELECTED_FILE: {
      return {
        ...state,
        selectedFile: action.payload,
      };
    }
    case SET_PASIEN_DEFAULT_STATE: {
      return {
        ...state,
        ...INIT_STATE,
      };
    }
    case SET_PASIEN_STARTDATE: {
      return {
        ...state,
        startDate: action.payload,
      };
    }
    case SET_PASIEN_ENDDATE: {
      return {
        ...state,
        endDate: action.payload,
      };
    }
    default:
      return state;
  }
};
